import { render, staticRenderFns } from "./close.vue?vue&type=template&id=556b704a&scoped=true&"
import script from "./close.vue?vue&type=script&lang=js&"
export * from "./close.vue?vue&type=script&lang=js&"
import style0 from "./close.vue?vue&type=style&index=0&id=556b704a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "556b704a",
  null
  
)

export default component.exports